import ActionSettingComp from "./ActionSettingComp.svelte";
import BooleanSettingComp from "./BooleanSettingComp.svelte";
import EnumSettingComp from "./EnumSettingComp.svelte";
import NumberSettingComp from "./NumberSettingComp.svelte";
import StringSettingComp from "./StringSettingComp.svelte";
import ColorSettingComp from "./ColorSettingComp.svelte";

export { default as SettingComp } from "./SettingComp.svelte";

export const Components = {
    "action": ActionSettingComp,
    "boolean": BooleanSettingComp,
    "enum": EnumSettingComp,
    "number": NumberSettingComp,
    "string": StringSettingComp,
    "color": ColorSettingComp,
}